export const LOAD_EMAIL_TEMPLATE = 'LOAD_EMAIL_TEMPLATE';
export const SET_EMAIL_TEMPLATE_PAGINATION = 'SET_EMAIL_TEMPLATE_PAGINATION';
export const SET_EMAIL_TEMPLATE_FILTERS = 'SET_EMAIL_TEMPLATE_FILTERS';
export const RESET_EMAIL_TEMPLATE_FILTERS = 'RESET_EMAIL_TEMPLATE_FILTERS';
export const ADD_EMAIL_TEMPLATE = 'ADD_EMAIL_TEMPLATE';
export const EDIT_EMAIL_TEMPLATE = 'EDIT_EMAIL_TEMPLATE';
export const LOAD_EDITABLE_EMAIL_TEMPLATE = 'LOAD_EDITABLE_EMAIL_TEMPLATE';
export const LOAD_EMAIL_TEMPLATE_TAGS = 'LOAD_EMAIL_TEMPLATE_TAGS';
